import type { CSSObject } from '@emotion/react';

export const inputDefault = ({
  visibility,
}: CSSObject): CSSObject => ({
  marginLeft: 2,
  marginRight: 2,
  marginTop: 2,
  marginBottom: 2,
  paddingBottom: 2,
  paddingTop: 2,
  visibility,
});

export const inputSmall = ({
  visibility,
}: CSSObject): CSSObject => ({
  marginLeft: 2,
  marginRight: 2,
  marginTop: 1,
  marginBottom: 1,
  paddingBottom: 0,
  paddingTop: 0,
  visibility,
});
